import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { LanguageService } from '../../../core/services/language.service';
import { Languages } from '../../enums/languages.enum';

@Component({
  selector: 'osp-public-footer',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './public-footer.component.html',
  styleUrl: './public-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicFooterComponent implements OnInit {
  protected languageService = inject(LanguageService);

  contactUrl = signal<string>('');
  legalNoticeUrl = signal<string>('');
  dataProtectionUrl = signal<string>('');
  websiteUrl = signal<string>('');

  ngOnInit() {
    if (this.languageService.getCurrentLocale() === Languages.DE) {
      this.initDeProperties();
    } else {
      this.initEnProperties();
    }
  }

  private initDeProperties(): void {
    if (environment.publicFooter?.de?.contactUrl) {
      this.contactUrl.set(environment.publicFooter.de.contactUrl);
    }
    if (environment.publicFooter?.de?.legalNoticeUrl) {
      this.legalNoticeUrl.set(environment.publicFooter.de.legalNoticeUrl);
    }
    if (environment.publicFooter?.de?.dataProtectionUrl) {
      this.dataProtectionUrl.set(environment.publicFooter.de.dataProtectionUrl);
    }
    if (environment.publicFooter?.de?.websiteUrl) {
      this.websiteUrl.set(environment.publicFooter.de.websiteUrl);
    }
  }

  private initEnProperties(): void {
    if (environment.publicFooter?.en?.contactUrl) {
      this.contactUrl.set(environment.publicFooter.en.contactUrl);
    }
    if (environment.publicFooter?.en?.legalNoticeUrl) {
      this.legalNoticeUrl.set(environment.publicFooter.en.legalNoticeUrl);
    }
    if (environment.publicFooter?.en?.dataProtectionUrl) {
      this.dataProtectionUrl.set(environment.publicFooter.en.dataProtectionUrl);
    }
    if (environment.publicFooter?.en?.websiteUrl) {
      this.websiteUrl.set(environment.publicFooter.en.websiteUrl);
    }
  }
}
